






















































import Vue from "vue";

// Component
import DeviceTree from "@/components/DeviceTree/index.vue";

export default Vue.extend({
    components: { DeviceTree },
    props: ["customAttrs", "button"],
    data() {
        return {
            isMenuOpen: false,
            DeviceTree,
            installationSelected: [],
            installationToFilter: [],
            reload: 0,
            alreadyApplied: false,
        };
    },
    computed: {
        canApply() {
            if (this.installationSelected.length > 1) return false;
            if (this.alreadyApplied) {
                if (this.installationToFilter.length == 1 && this.installationSelected.length == 0) return true;
                if (this.installationSelected.length == 1 && this.installationToFilter.length == 0) return true;
                if (this.installationSelected[0] != this.installationToFilter[0]) return true;
            } else if (this.installationSelected.length) return true;

            return false;
        },
        canDeleteFilters() {
            if (this.installationToFilter.length) return true;
            return false;
        },
    },

    methods: {
        onApply() {
            if (this.installationSelected.length) {
                if (this.installationToFilter.length > 0) this.installationToFilter.splice(0, 1);
                this.installationToFilter.push(this.installationSelected[0]);
                this.$emit("input", this.installationToFilter[0].name);
            } else {
                if (this.installationToFilter.length) this.installationToFilter.splice(0, 1);
                this.$emit("input");
            }
            this.alreadyApplied = true;
        },
        reset() {
            this.installationSelected.splice(0, 1);
            this.onApply();
        },

        closeMenu() {
            this.isMenuOpen = false;
        },
    },
});
